export const FeatureGates = {
    BkHurdlrSdk: 'bk_hurdlr_sdk',
    BkClosingsUi: 'bk_closings_ui',
    HubTransactionsV2: 'hub_transactions_v2',
    BkReviewTransactionsFromPostgres: 'bk_review_transactions_from_postgres',
    BankStatementsSettingsPage: 'bank_statements_settings_page',
    ImpactAdvocateEnabled: 'enable_impact_advocate_referrals',
    EmployeeAdvocateEnabled: 'enable_employee_advocate_referrals',
    TaxfyleITRFree2025: 'taxfyle_itr_free_2025',
    EnableAgentAssist: 'agent_assist_enabled',
    EnableEMCallBanner: 'enable_em_call_banner',
    EnableOACallBanner: 'enable_oa_call_banner',
    EnableHubScheduleMeeting: 'enable_hub_schedule_meeting',
    EnableHubCallPrep: 'hub_call_prep_enabled',
    HubOffboardingAgent: 'hub_offboarding_agent',
    BIZVerificationForceVerifyTask: 'biz_verification_force_verify_task',
    BypassTakeoverSsnRequirement: 'bypass_takeover_ssn_requirement',
    DocumentUsePGParser: 'document_use_pg_parser',
    CalComIntroCallEnabled: 'calcom_intro_call_enabled',
    // Accounting Setup: verify each uploaded bank statement (is it a statement, right
    // account, needed month) and drive the ask from the coverage endpoint. Off = the
    // legacy "most recent statement" per-account rows.
    AccountingSetupStatementVerification: 'accounting_setup_statement_verification',
    // The V1 accounting setup redesign, gated as one unit for the whole epic (AP-2905).
    // On = statement sync and manual statement upload belong to business accounts setup
    // (/onboarding/biz-account-setup/*) and accounting setup no longer owns
    // connect_automated_statements_status. Off = today's production flow, statements
    // inside the accounting wizard.
    //
    // Deliberately one gate rather than one per story: partial gating produces hybrids
    // where a member sees the statements step twice or never sees it at all.
    AccountingSetupRedesignV1: 'accounting_setup_redesign_v1',
    ReferralPrompt: 'ca_4688_referral_prompt',
    Relay50Offer: 'relay_50_offer',
    ProjectInboxPoc: 'project_inbox_poc',
    EnableFeatureGateOverrideManager: 'enable_feature_gate_override_manager',
    MemberTasksUiEnabled: 'member_tasks_ui_enabled',
    EoyCleanupEnabled: 'eoy_cleanup_enabled',
    PauseExtensionSubmission: 'pause_extension_submission',
    ShowInsuranceContent: 'show_insurance_content',
    QtePaymentRemittanceEnabled: 'qte_payment_remittance_enabled',
    // The Quarterly payments page's "coming up" state between estimate windows (TAX-3770). Off = the
    // page decides the quarter from the old client-side cutoffs, as before.
    QteTransitionStateEnabled: 'qte_transition_state_enabled',
    PayrollSetupSkipGustoReqs: 'payroll_setup_skip_gusto_reqs',
    EnableDemoLinkInSalesPortal: 'enable_demo_link_in_sales_portal',
    StatementPerAccountDates: 'statement_per_account_dates',
    Enable1800AccountantDqHandoff: 'enable_1800accountant_dq_handoff',
    Enable1800AccountantNative: 'enable_1800_accountant_native',
    // Closes ITR purchase for TY2025: non-purchased members get the upload-your-return view
    // instead of the package purchase flow, and dashboard ITR promotions are suppressed.
    ItrPurchaseDisabled2025: 'itr_purchase_disabled_2025',
    FormationNameCheckViaVendor: 'formation_name_check_via_vendor',
    FormationQreHold: 'formation_qre_hold',
    FormationMoveToVendor: 'formation_move_to_vendor',
    TakeoverQreHold: 'takeover_qre_hold',
    PalmFormationsHubView: 'palm_formations_hub_view',
    ForeignRegistrationHubView: 'foreign_registration_hub_view',
    FormationAuditExport: 'formation_audit_export',
    DisableFacebookBrowserEvents: 'disable_facebook_browser_events',
    BulkDownloadToDocumentCenter: 'bulk_download_to_document_center',
    EnableAgentOps: 'enable_agent_ops',
    // Renders every Agent Ops escalation from the component registry its payload names. There is no
    // per-escalation fallback: with the gate on, an escalation without a render payload gets the
    // bug-report card, not the old card — so do not enable this until the backend writes payloads
    // for every open escalation (collective-backend#11975).
    AgenticEscalationCards: 'agentic_escalation_cards',
    // Paints the Agent Ops Work tab's escalation area as a Canvas surface. Off means the Work tab
    // never asks for a surface and renders today's escalation cards; on, a task with no agent or no
    // brief for its template (a 404 from the surface lookup) still gets those cards.
    AgentOpsA2uiRenderer: 'agent_ops_a2ui_renderer',
    // Merges a registration's notes across its stages in the ER workspace. Off means each stage
    // shows only its own notes, which is what every other queue does.
    ErGroupNotes: 'er_group_notes',
    // Collapses the ER queue to one row per registration. Off means one row per stage, which is
    // what the queue did before grouping and what every other queue does.
    ErGroupTasks: 'er_group_tasks',
    // Shows "Request account closure" on ER tasks, the only way to open a closure task. Off until the
    // ER team moves closures from Jira to the Hub.
    ErCloseRegistration: 'er_close_registration',
    AdhocAgentDevtool: 'adhoc_agent_devtool',
    // The Hub developers page that scores an EOY review workbook into a Braintrust experiment. The
    // backend reads the same gate and 404s the API while it is off.
    EoyReviewEvalDevtool: 'eoy_review_eval_devtool',
    // The Hub developers Canvas Playground page: its nav entry and its route. The backend does not read
    // it; the playground API is open to every employee.
    CanvasPlaygroundDevtool: 'canvas_playground_devtool',
    PayrollDashboardV2: 'payroll_dashboard_v2',
    // Payroll alerts for members: the Notifications page here, and the Overview's alert banner via
    // the backend, which reports no blocking alerts while it is off.
    PayrollNotifications: 'payroll_notifications',
    PayrollPayScheduleInlineLink: 'payroll_pay_schedule_inline_link',
    PayrollPayScheduleNativeView: 'payroll_pay_schedule_native_view',
    // Swaps the off-cycle run at `/payroll/off-cycle` from our own Formik form to the Gusto-hosted
    // `run_off_cycle_payroll` flow in an iframe. Gated at the destination page, not at each caller,
    // so the Overview card, the Team page button and the compensation catch-up all move together —
    // two ways to create the same payroll, live at once, is the failure this avoids.
    // OFF is exactly today's product.
    PayrollOffCycleGustoFlow: 'payroll_off_cycle_gusto_flow',
    // Mounts Gusto's embedded Time Off flow at `/payroll/time-off` and shows the sidebar entry.
    // OFF (the default) keeps the route a 404 and hides the nav item, so production stays exactly
    // as it is today until we flip the gate. Staging / pre-prod turn it on to exercise the proxy
    // allowlist and the embedded SDK against a real Gusto company before production rollout.
    // The Payment tab on a team member's detail page. ON renders Gusto's management blocks
    // (`EmployeeManagement.PaymentMethod` / `ContractorManagement.PaymentMethod`) inline: the
    // current method, bank accounts, and add/edit/remove in one place. OFF (the default) keeps our
    // read-only card with the "Change payment method" dialog. A worker who can't be matched to Gusto
    // (no email, no unique match, or a failed lookup) falls back to the read-only card either way.
    PayrollWorkerPaymentManagement: 'payroll_worker_payment_management',
    // Only matters with `PayrollDashboardV2` on. ON keeps the legacy "Dashboard" entry (at
    // `/payroll/dashboard`) alongside the new pages; OFF shows the new pages alone. With
    // `PayrollDashboardV2` off the legacy dashboard shows whatever this says.
    PayrollDashboardV2ShowLegacy: 'payroll_dashboard_v2_show_legacy',
    // The Family subsection on the payroll team page: who on payroll is the member and their spouse,
    // with the actions to correct either. OFF hides the subsection and never reads `team/family/`.
    // AP-2721. OFF (the default), the Overview's "View details" opens the shared
    // `PayrollBreakdownModal` the History page already uses. ON, it opens
    // `PayrollRunDetailsDialog`, which renders the v1 run-detail payload directly and is the
    // only one of the two that shows per-line amounts. A gate rather than a swap so the
    // per-line surface can be turned on per environment, and turned back off without a deploy
    // if it misbehaves against real provider data.
    PayrollRunDetailsV1: 'payroll_run_details_v1',
    // OFF (the default), My Compensation shows salary progress as the paid-against-goal bar and the
    // compensation slider jumps straight to a typed or clicked value. ON, the page leads with two
    // figures (behind the pay schedule today, short of the salary by Dec 31), draws the year as a
    // paid line forking at today into the target and the current pace, the update wizard redraws
    // that line live as the slider moves, and the slider glides.
    PayrollCompensationYearChart: 'payroll_compensation_year_chart',
    // The Payroll Overview's reasonable comp card leads with "$X paid of $Y" and a bar.
    PayrollRcOverviewPaidOfGoal: 'payroll_rc_overview_paid_of_goal',
    // The "Set your reasonable compensation" panel says what the owner has been paid this year.
    PayrollRcSetupPanelPaidThisYear: 'payroll_rc_setup_panel_paid_this_year',
    // The backend's switch for raising the weekly "Review your reasonable compensation" member task.
    // ON, that task is how a member with no salary is prompted, so the Payroll Overview drops its
    // own "Set your reasonable compensation" banner rather than say the same thing twice.
    ReasonableCompensationReviewTask: 'reasonable_compensation_review_task',
    // The payroll setup status card on the member's own payroll home. Off, a member mid-setup sees
    // what they see today: the marketing screen and a "Set up payroll" button, with nothing saying
    // where their setup actually is or which side the wait is on.
    PayrollSetupStatusCard: 'payroll_setup_status_card',
    // AP-1768: the Decagon help entrypoint on each transaction row — the sparkle in the
    // Description cell. Placement and discoverability are being trialled on real members,
    // so it ships flippable rather than baked in.
    TxnRowHelpEntrypoint: 'txn_row_decagon_help_entrypoint',
    // AP-2448: the per-question Decagon entrypoints in Accounting Setup. Covers the whole change
    // — both which links exist and where a click goes — so one flip is a complete rollout or a
    // complete rollback, and OFF is exactly the product that shipped before it.
    //
    // ON, a click creates a conversation server-side carrying `page: accounting-setup`, which is
    // the condition the setup AOP already conditions its own visibility on in prod; the answer
    // then comes from the setup AOP rather than the default one. The three entrypoints AP-2448
    // added also appear: Import Transactions, the document checklist's statements header, and
    // Accounting Progress (which swaps its help-centre article for the agent).
    //
    // OFF, those three are gone and the links that predate AP-2448 open the generic widget with
    // the same question the member clicked, as they do today.
    //
    // Two things AP-2448 changed for both branches, deliberately NOT gated: the questionnaire and
    // reimbursement questions were reworded from support-ticket phrasing ("Help with tax filing
    // questions for...") to the member's actual question, and the section header in
    // UploadDocuments/components/QuestionSection went h6 -> h4 per the design. Gating either would
    // mean carrying two copies of every string, and better phrasing helps the default AOP too. So
    // OFF is the pre-AP-2448 product in structure and routing, not to the pixel or the character.
    //
    // Because the AOP gates its own visibility on that metadata, flipping this on cannot reach a
    // member outside the setup flow. What it trials is placement and discoverability on real
    // members — same reason as TxnRowHelpEntrypoint above.
    AccountingSetupHelpEntrypoint: 'accounting_setup_decagon_help_entrypoint',
    // The same gate the BE reads: routes request creation through the member-request service, which
    // gives every request an owning review task. One flip has to move both sides or they disagree.
    MemberRequestReviewEnabled: 'member_request_review_enabled',
    // `/settings/bank-accounts?institution=<plaid institution id>`: scroll to that connection, flash
    // it, and reopen the bank login when it is broken. Off, the param is ignored and left in the URL
    // — the page behaves exactly as it did before the deep link existed.
    BankRelinkDeepLink: 'bank_relink_deep_link',
    // Kill switch for the Help Agent deep-link `?message=` prefill (HUB-2085). OFF (the default, and
    // what an unknown gate evaluates to) means prefill is live; ON means the widget still opens from
    // `?drawer=helpagent` but the message is dropped. Pause polarity matches pause_extension_submission.
    HelpAgentDeeplinkMessagePaused: 'help_agent_deeplink_message_paused',
    // TAX-3656: the re-consent modal on Home and Tax that collects a TAX_RETURN_CONSENT v2 grant
    // from members still holding the v1 one. Off means the check endpoint is never called.
    // The same gate the BE reads: preloads eight business-identity scalars onto the Decagon
    // conversation metadata (HUB-2023) so the identity AOPs can answer without a tool call. Both
    // sides have to build the same map until HUB-1909 unifies the two init paths, so one flip has
    // to move both or an agent-assist conversation and a member conversation disagree. Off means
    // the metadata is exactly what it is today.
    DecagonBusinessContextMetadata: 'decagon_business_context_metadata',
    TaxAutomation: 'tax_automation_enabled',
    // HUB-2339: the same gate the BE reads to project member-facing Zendesk responses. Here it also
    // puts a newly created Message Center ticket into the list straight away (Zendesk's requested
    // tickets can lag a fresh create), loads both list tabs from one request, and shows an error
    // with Try again when a conversation can't load. Off means the Message Center behaves exactly
    // as it does today.
    ZendeskMemberProjection: 'zendesk_member_projection',
    // Hub's Missing Transactions Investigation page: the account picker, the named results and the
    // statement step. Off means today's form and debug report.
    HubMissingTransactionsInvestigateWithStatements: 'hub_missing_transactions_investigate_with_statements',
    // Billing history list in Settings > Membership; the backend 404s while this is off.
    MemberBillingHistory: 'member_billing_history',
} as const;

export const DynamicConfigs = {
    IMCResponseTimeMessage: 'imc_response_time_message',
    OutageAlertSnackbar: 'outage_alert_snackbar',
    PendingCallBanner: 'checkout_urgency_banner',
    CheckoutAutoApplyCoupons: 'checkout_auto_apply_coupons',
    ReferralPromoConfig: 'referral_promo_config',
    HealthInsuranceConfig: 'health_insurance_config',
    CoverdashLaunchpadConfig: 'coverdash_launchpad_config',
    RetroSBackBooksPrices: 'retro_s_back_books_prices',
    TaxSavingsCalculatorStaticData: 'tax_savings_calculator_static_data',
    FunnelInstantCallbackAfterHours: 'funnel_instant_callback_after_hours',
    // One boolean per column id, true to show it. Unset means every optional column is hidden,
    // which is what the ER queue ships with.
    ErQueueColumns: 'er_queue_columns',
    // `business_days`: how long the payroll provider needs between today and a check date. Unset
    // means 4-day processing; set it to 2 if we move to a 2-day window.
    PayrollProcessingWindow: 'payroll_processing_window',
    // One mode per Overview widget — `hidden`, `readonly` or `write`, keyed by card name. Unset
    // means every widget is visible but readonly, so a card ships inert until a rollout grants it
    // a write action. The backend served these until #12025 and stopped on purpose, so rollout
    // sequencing lives here now.
    PayrollOverviewWidgets: 'payroll_widget_modes',
    // One boolean per operator queue id, true to render that queue's task table through Material
    // React Table instead of the hand-written one, plus a `default` key for every queue without one.
    // Unset means every queue keeps today's table, which is what the Hub ships with — so the rollout
    // is per queue and reversible without a deploy. Callers pass an id from their own queue
    // registry rather than a literal.
    HubTableMrt: 'hub_table_mrt',
    // Shared with the statement extraction pipeline. `retro_s_only` narrows the audience for
    // verified statement upload — see useStatementVerificationEnabled. Unset means no narrowing,
    // so the feature gate alone decides.
    BkStatementExtractionConfig: 'bk_statement_extraction_config',
    // Shared with the backend. `institutions[].plaid_ids` lists the banks we no longer offer Auto
    // Statements for — see unreliableInstitutions.ts. Unset means every bank is offered.
    QuilttUnreliableInstitutions: 'quiltt_unreliable_institutions',
    // `tax_year`: which ITR year the re-consent check asks about. Unset means 2025, so the config
    // only has to be touched when the cohort moves to a later filing year.
    ITRReconsentConfig: 'itr_reconsent_config',
} as const;
